export default "__VITE_ASSET__DjcE5sO3__"